import { BUTTON_HEIGHT_32 } from '../../../Button'
import { PageActionsButtonAddEntity } from '../../../PageActionsButtonAddEntity'
import { ButtonIconSelectControl, ButtonSelect } from '../../../Select'

import * as styles from './RequestProfileActionsWidgetAddNewButton.module.css'

function RequestProfileActionsWidgetAddNewButton({
  className = styles.RequestProfileActionsWidgetAddNewButton,
  dropdownPlacement,
  options,
  qaName,
  tooltip,
  tooltipPlacement,
  onSelectOption,
}) {
  return (
    <ButtonSelect
      Control={ButtonIconSelectControl}
      className={className}
      controlProps={{
        Button: PageActionsButtonAddEntity,
        buttonProps: {
          height: BUTTON_HEIGHT_32,
          qaName,
          tooltip,
          tooltipPlacement,
        },
      }}
      dropdownFloatingConfig={{ dropdownPlacement, maxWidthByRef: false }}
      listProps={{
        className: styles.dropdown,
        headerProps: {
          Search: null,
        },
      }}
      options={options}
      onSelectItem={onSelectOption}
    />
  )
}

export default RequestProfileActionsWidgetAddNewButton
